'use client';

import AppLink from './AppLink';
import { useLandingAccount } from '../../lib/landingAccount';
import { getSiteCopy } from '../../lib/siteI18n';

export default function SessionActions({ locale = 'en', location = 'hero', children }) {
  const account = useLandingAccount();
  const copy = getSiteCopy(locale).nav;
  if (!account) return children;
  const guest = account.kind === 'guest';
  return <div className="landing-session-actions">
    <AppLink href={`/app/dashboard?lang=${locale}`} className="btn hero-primary-btn"
      data-analytics-cta-id={`${location}_my_transcripts`} data-analytics-cta-location={location}>
      {copy.workspace}
    </AppLink>
    <AppLink href={`/app/${guest ? 'signup' : 'dashboard/profile'}?lang=${locale}`} className="email-signup-link"
      data-analytics-cta-id={`${location}_${guest ? 'complete_signup' : 'account'}`} data-analytics-cta-location={location}>
      {guest ? copy.completeSignup : copy.account}
    </AppLink>
  </div>;
}
